import React from 'react';
import { PieChart } from 'lucide-react';
import { BoxProps } from '@mantine/core';
import { IconWrapper } from './IconWrapper';

interface PieChartIconProps extends BoxProps {
    size?: number;
    color?: string;
}

export const PieChartIcon: React.FC<PieChartIconProps> = ({ size = 32, color, ...props }) => {
    return (
        <IconWrapper size={size} {...props}>
            <PieChart size={size} color={color} />
        </IconWrapper>
    );
};
